module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "page12",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("I take my bagel and coffee and drive to my private office on Catalan Court. One of the many things I love about Fran is that she never sees my flaws, only my assets. What she doesn’t know or doesn’t want to acknowledge is that, after four years on the job at KPD, there are still officers who avoid me like the plague, believing I have a video cam in this office and in my office at headquarters, both of which go straight to the chief. As for my ability to help, Fran seems to have forgotten Ben Gomez, the young rookie who killed himself. I have mourned for him in silence almost every day since. Tortured myself with questions about what I missed, what more I could have done to prevent his death. Fran will have to find a different therapist for her goddaughter. I am not ready to work with another potentially suicidal young client. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("I pull into the parking area behind the building where my private office is located, noticing for the first time what a beautiful summer day it is, sunny and hot. I wave at the gardener who is pulling weeds and deadheading bushes along the walkway. Gary Morse is sorting mail in the lobby. Concentrating so hard he doesn’t hear me come through the door. He’s dressed, as usual, in a beat-up corduroy jacket with leather patches on the elbows. Gary, his wife, Janice, and I have a long history. I’ve known them both since grad school. They were the ones who warned me off Mark, my ex. After our divorce, when I was convinced the romantic part of my life was dead and gone, they introduced me to Frank, who was remodeling their house. When Frank proposed and I had a serious case of cold feet, they kept nagging at me until I agreed to marry him. It was the right decision and I’m forever grateful they knew it before I did.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "page13",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Coming to the staff meeting today?” Gary’s mellow voice is as soothing as the sticky sweet aroma of pipe tobacco that clings to his clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Once a month, all the therapists in our building get together for coffee and companionship. I don’t have much in common with the other therapists. They all have conventional practices, treating the usual grab bag of presenting problems. My clients carry weapons and live in a kill-or-be-killed world. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Gary hands me my mail. I walk up the stairs to my second-floor office and dump the pile on my desk, toss the circulars and the ads, and stack the professional journals on top of the eight-inch pile of unread past issues I’ll probably never get to. I’m about to check my schedule for the day when Fran texts me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She’s here, at the café. Showed up out of nowhere. She’s been sleeping in her car for two days. On my way to U.")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("Fran looks worse than she did an hour ago. Standing in my waiting room, her hands clamped over Ava’s shoulders, holding her steady. I tell her I have forty minutes until I have a preemployment interview. Forty minutes I need to review the applicant’s test results and background packet. She tells me she won’t take that long, she just wanted to introduce me to Ava. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is this a doctor’s office?” Ava looks around. “I thought you said we were going to see your friend and then out to lunch.”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "10",
      "epub:type": "pagebreak",
      "id": "page14",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dot is my friend. She’s also a doctor, a psychologist.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ava wheels toward the door. She’s a tiny girl with an unruly mound of dark curly hair and deep brown eyes. Her skin is the color of weak tea. Bony knees stick out of the holes in her jeans. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I don’t need a psychologist.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That, my dear Ava, is a matter of opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m eighteen. I’m an adult. I don’t have to do anything I don’t want to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What you are is mixed-up, confused, and highly emotional. It comes with being eighteen.” Fran turns to me. “This is as much as I know. Ava and her parents had a big fight. Ava threw a tantrum and left home.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not throw a tantrum. I got angry. There’s a difference. My father doesn’t need to know where I am every minute of every day, which is what he wants.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If you’re going to stay with me tonight, I am going to call them and tell them where you are, so they won’t worry. This is not negotiable. Unless you’d rather sleep in your car.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Whatever,” Ava says. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Fran takes her phone and walks into the waiting room, closing the door to my office behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Might as well have a seat while you’re waiting,” I say. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No thanks.” Ava walks over to a set of colorful framed textiles that hang over a bookcase. Hand-embroidered little boy’s pants and huipils from Guatemala. “These are pretty. Are they from Mexico?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Guatemala.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Have you been there?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Once, when I was in college. It’s very beautiful.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She circles around the room, touching things with her delicate hands. She moves with precise steps like a dancer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s this?”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "11",
      "epub:type": "pagebreak",
      "id": "page15",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She stops in front of a blue-and-gold ceramic bowl that sits on a low coffee table in front of the couch.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A client made that for me using a Japanese technique called kintsugi, mending broken pottery with lacquer that’s mixed with powdered gold.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why did she make it for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was a thank-you gift for helping her. She wanted me to keep it here to show my other clients that the woman who made it is no longer broken. That if she could put herself back together, so can they.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ava runs her finger along the rim of the bowl. “It’s hella beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Fran’s muffled voice, but not her words, comes through my office door. Ava keeps walking.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Fran’s my godmother. I call her my aunt. It’s easier. I guess she told you that I was adopted.” Ava looks for my reaction. I do my neutral screen face thing. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She continues to circle the room. Stops in front of another bookcase. “Have you read all these books?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I love to read.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What kind of books do you like?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She shrugs. “Fiction mostly.” She tracks her hand over the top of the bookcase, picks up a small pine needle basket, turns it over, glances at the bottom, and puts it back. “Cool. Who made it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not sure. I think it’s "), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Ohlone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So what kind of shrink are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m a police psychologist.” Her dark eyebrows lift slightly. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You see cops after they shoot people?”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "12",
      "epub:type": "pagebreak",
      "id": "page16",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sometimes. Mostly they don’t shoot people.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My father was a cop, here in Kenilworth. He quit and moved to Moss Point when I was a baby.” She’s still pacing. “Do you see many cops’ kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A few.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My father acts like he’s still a cop. Watches my every move. Wants to know where I am all the time. Is that normal?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Cops see a lot of bad stuff that happens to children. It makes them afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But is it normal? He only sees the bad stuff, never the good. Acts like there’s a bad guy around every corner. Talks to me like I’m a crook.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The door opens, Fran comes back into the office. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That wasn’t easy, but your parents said you can stay for the night. Your father’s hopping mad and your mother is on the verge of hysterics she’s been so worried about you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He’s always mad and she’s always a nervous wreck. I want to stay with you for the whole summer.” Fran looks surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“One day at a time, please. That’s a big ask. First things first, you need a shower, a shampoo, and a good meal. You’re skinny as a scarecrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He hit me, I bet he didn’t tell you that.” Fran and I freeze. “He was mad. So was I. Didn’t give him the right to slap me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How often has this happened?” I ask, switching into therapist mode as a mandated reporter of child abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Just once.” Her voice is so soft I can barely hear her. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Again, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Once. But he says shit all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m eighteen, I want to look for my birth parents. Just like millions of other adopted kids. Dan and Sharon go mental every time I bring it up. That was what the fight was about. Dan said he hoped my birth mother would turn out to be a slut who gives blow jobs to vagrants for money. My mother told me he didn’t mean it. It was just cop humor. She always says that after he’s had a few beers and says something gross. My dorky friend Cody thought it was funny, told me to lighten up.” She turns to Fran. “And you probably think I’m too sensitive.”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "page17",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What I think is not for print and it has to do with Dan, not you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ava turns to me. “You’re a doctor, what do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It’s not so much a question as a test. Am I going to judge her or understand how painful this was?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think that was an awful thing for him to say. It was cruel.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Something softens around her eyes, then just as quickly tightens again. “No biggie. He can say whatever he wants, I don’t care. I already know who my birth mother is and that she lives in San Francisco with my grandmother.” She walks to the window, gazes out as she’s talking, her face dappled with shadows from the maple tree outside. She’s so petite that if I didn’t know she was eighteen, I’d think she was much younger. Fran looks at me and shrugs her shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’ve already met your birth mother?” I ask. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She hesitates a second. “I talked to her on the phone. Once.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("I start to ask why only once when she turns away. “I’m hungry, Aunt Fran. Let’s get lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Fran gets up, shaking her head at the rapid change in Ava’s mood and muttering something about needing a drink, not a sandwich. “Thanks for your time, Dot. I owe you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Bye, Ava,” I say. “Nice to meet you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Same here.” She gives me a little wave and walks out.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("I close the door. If I work fast, I can read my applicant’s records. I open his file, but I can’t concentrate. Ava is not who I was expecting. She’s bright and curious. And way more forthcoming than I imagine most teenagers are. Her home life sounds difficult. An angry, controlling father who drinks too much and an emotionally volatile mother. I don’t know anything about her history, but she strikes me as angry and rebellious—probably normal for her age—not depressed or suicidal. Then again, I knew a lot about Ben Gomez. I didn’t think he was suicidal either, not until he shot himself in the head.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "page18",
      "role": "doc-pagebreak"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa94746c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CallMeCarmela-2.vue
// module id = 75
// module chunks = 0